import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const SignInCapthcaPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fromManual = searchParams.get("from") === "manual";

  useEffect(() => {
    if (fromManual) {
      navigate("/dl/manual", { replace: true });
    } else {
      navigate("/menu", { replace: true });
    }
  }, [navigate, fromManual]);

  return null;
};

export default SignInCapthcaPage;
